import { render } from "./certificate.vue?vue&type=template&id=0b8c87b9&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"

import "./certificate.vue?vue&type=style&index=0&id=0b8c87b9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b8c87b9"

export default script